import React from 'react'
import { Button, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import { Trans, useTranslation } from 'react-i18next'

export default function ConfirmNotAPersonOverlay({ overlay, handleClickConfirmNotAPerson }) {
  const [t] = useTranslation()

  return (
    <DialogOverlay
      {...overlay}
      title={t('task-viewer.confirm-not-a-person-overlay.heading', 'Are you sure?')}
      nonClosable
      footer={
        <DialogOverlayActions>
          <Button
            data-testid="decline-not-a-person-button"
            onClick={overlay.close}
            emphasis="low"
            linkName="Confirm Not A Person Overlay Decline Button"
          >
            {t('tasks-done-overlay.confirm-not-a-person-overlay.cancel-button', 'Cancel')}
          </Button>
          <Button
            data-testid="confirm-not-a-person-button"
            onClick={handleClickConfirmNotAPerson}
            emphasis="high"
            linkName="Confirm Not A Person Overlay Confirm Button"
          >
            {t('tasks-done-overlay.confirm-not-a-person-overlay.confirm-button', 'Not a Person')}
          </Button>
        </DialogOverlayActions>
      }
    >
      <Trans i18nKey="tasks-done-overlay.confirm-not-a-person-overlay.message">
        <Paragraph size="sm">
          <b>Not a Person</b> means that the highlighted word&#40;s&#41; don&apos;t belong to a person.
          <span>Please confirm.</span>
        </Paragraph>
      </Trans>
    </DialogOverlay>
  )
}
